import { useEffect, useRef } from "react";
import InfoPersoStep3Bloc from "../blocs/info-perso/InfoPersoStep3Bloc";
import { isMobile, scroll2Top } from "../utils/utils";
import GeneralDataProtectionBloc from "../blocs/common/GeneralDataProtectionBloc";

export default function InfoPersoStep3Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
     
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Accélérez vos remboursements: joignez votre attestation de droits</h1>
        <p className="text ml-lg-desktop mt-sm" style={{textAlign: 'justify'}}>Votre attestation de droits à l’Assurance maladie nous permet de mettre en place des échanges automatisés avec votre caisse pour accélérer vos remboursements.</p>
        <p className="text ml-lg-desktop" style={{textAlign: 'justify'}}>Ce document est indispensable à la finalisation de votre affiliation.</p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoStep3Bloc/>
        </div>
          <GeneralDataProtectionBloc/>
      </div>
     
    )

}